module.exports = __webpack_public_path__ + "img/architecture3.07e7db25.webp";